import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import './select.scss'
import SectionContentTypes from "./ContentTypes.jsx";
const uuidv4 = require('uuid/v4')

class ColorSelector extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            color: this.props.value || '',
            variables: this.props.variables || '',
            uniqueId: uuidv4(),
        }
        this.chooseColor = this.chooseColor.bind(this)
    }

    componentDidMount() {

    }

    chooseColor(e) {
        this.setState({
            color: e.target.value,
        }, () => {
            this.state.onChange(this.state.color)
        })
    }

    render() {
        return (
            <form>
                <div className="row d-flex flex-row">
                    <div className="mx-1">
                        <div className={"row"}>
                            <div className={"col-12 d-flex justify-content-center"}>
                                <label htmlFor={'color-picker-' + this.state.uniqueId + '-empty'}>
                                    <div className={'border crossed-red'} style={{
                                        backgroundColor: '#ffffff',
                                        width: '80px',
                                        height: '40px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                    }} />
                                </label>
                            </div>
                            <div className={"col-12 text-center"}>
                                <input
                                    id={'color-picker-' + this.state.uniqueId + '-empty'}
                                    name={'color-picker-' + this.state.uniqueId}
                                    type={'radio'}
                                    checked={'' === this.state.color}
                                    onChange={this.chooseColor}
                                    value={''}
                                />
                            </div>
                        </div>
                    </div>
                    {SectionContentTypes.getUniquesColorsFromVariables(this.state.variables).map((color, key) => {
                        return <div className="mx-1" key={key}>
                            <div className={"row"}>
                                <div className={"col-12 d-flex justify-content-center"}>
                                    <label htmlFor={'color-picker-' + this.state.uniqueId + '-' + color}>
                                        <div className={'border'} style={{
                                            backgroundColor: color,
                                            width: '80px',
                                            height: '40px',
                                        }} />
                                    </label>
                                </div>
                                <div className={"col-12 text-center"}>
                                    <input
                                        id={'color-picker-' + this.state.uniqueId + '-' + color}
                                        name={'color-picker-' + this.state.uniqueId}
                                        value={color}
                                        type={'radio'}
                                        checked={color === this.state.color}
                                        onChange={this.chooseColor}
                                    />
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </form>
        );
    }
}

export default ColorSelector


// WEBPACK FOOTER //
// ./src/template/sections/content/colorselect.component.jsx